import React, { Fragment, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ActionButton } from './ActionButton';
function useCountdown() {
  const [seconds, setSeconds] = useState(23 * 3600 + 55 * 60 + 25);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(value => String(value).padStart(2, '0'));
}
interface PricingProps {
  showAnchor?: boolean;
}
export function Pricing({
  showAnchor = false
}: PricingProps) {
  const [hours, minutes, seconds] = useCountdown();
  return <section id={showAnchor ? 'pricing' : undefined} className="bg-brand-dark" data-id="element-94" data-mp="20sv8mn7thoyc">
      <div className="bg-[#1c0909] px-4 py-16 sm:py-20" data-id="element-95" data-mp="3h74o0ru303d1">
        <div className="mx-auto max-w-4xl text-center" data-id="element-96" data-mp="3h5jsozzy0ge4">
          <h2 className="font-display text-xl font-bold sm:text-2xl" data-id="element-97" data-mp="3c934k5squ211">
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
          <div className="mt-6 flex justify-center gap-3 sm:gap-6" data-id="element-98" data-mp="3vyx8s3w8o6h5">
            {[[hours, 'HS'], [minutes, 'MIN'], [seconds, 'SEG']].map(([value, label], index) => <Fragment key={label} data-id="element-99" data-mp="9qe71mu7du41" data-mpi={index}>
                <div data-id="element-100" data-mp="erletlwcitap">
                  <p className="font-display text-5xl font-bold text-red-500 sm:text-7xl" data-id="element-101" data-mp="eq0lfzlrpgef">{value}</p>
                  <p className="text-xs tracking-[.2em] text-slate-400" data-id="element-102" data-mp="3daa3ple2bh3k">{label}</p>
                </div>
                {index < 2 && <span className="pt-2 font-display text-4xl text-red-500 sm:text-6xl" data-id="element-103" data-mp="3i5pfm7sif2xc">:</span>}
              </Fragment>)}
          </div>
          <p className="mt-6 text-slate-400" data-id="element-104" data-mp="3rzeptdnza5gy">
            Después sube. <b className="text-white" data-id="element-105" data-mp="2uizk7pao26lp">No vuelve.</b>
          </p>
          <div className="mx-auto mt-5 max-w-md rounded-xl border border-red-500/20 bg-brand-ink p-4 text-left" data-id="element-106" data-mp="2ugn2nd8tly96">
            <div className="flex justify-between text-sm font-medium text-red-400" data-id="element-107" data-mp="2rgv09f5lnye9">
              <span data-id="element-108" data-mp="2rei8kaa1i9o0">Cupos al precio de lanzamiento</span>
              <span data-id="element-109" data-mp="2mh0a5dtnfcu9">Quedan pocos</span>
            </div>
            <div className="mt-3 h-2.5 overflow-hidden rounded-full bg-slate-800" data-id="element-110" data-mp="316o9i9i9s1fc">
              <div className="h-full w-[68%] rounded-full bg-red-500" data-id="element-111" data-mp="318in12r7or9e" />
            </div>
            <p className="mt-2 text-right text-xs text-slate-500" data-id="element-112" data-mp="2w9o50312j6qc">68% de los cupos ya tomados</p>
          </div>
        </div>
      </div>

      <div className="px-4 py-16 sm:py-24" data-id="element-113" data-mp="23jfk43f5e882">
        <div className="mx-auto max-w-2xl" data-id="element-114" data-mp="23kgwqcbtb2rw">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-115" data-mp="2ifwvgunc7mum">
            TU SISTEMA COMPLETO
          </h2>
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-8 rounded-3xl border-2 border-brand-green bg-brand-ink p-6 shadow-[0_0_30px_rgba(22,163,74,.13)] sm:p-9" data-id="element-116" data-mp="2dg23enrtsr7z">
            <div className="flex flex-col gap-4 sm:flex-row sm:justify-between" data-id="element-117" data-mp="59gno47o3nnt">
              <div data-id="element-118" data-mp="573zh9bbgh2b">
                <h3 className="font-display text-lg font-bold text-brand-light" data-id="element-119" data-mp="3nfcwsi57kb2o">
                  🌿 PROTOCOLO RESCATE SIBO™
                </h3>
                <p className="mt-1 text-sm text-slate-400" data-id="element-120" data-mp="3rh6vwlzr970q">
                  5 Volúmenes + 5 Bonos · Acceso inmediato
                </p>
                <p className="mt-3 text-sm text-brand-light" data-id="element-121" data-mp="nzyge8si2j96">
                  300+ páginas en PDF + 5 bonos estratégicos de regalo.
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-122" data-mp="a8b8fbp73mak">
                <p className="text-slate-500 line-through" data-id="element-123" data-mp="e9d9ly2oa8f6">$65.000</p>
                <p className="font-display text-4xl font-bold text-brand-light" data-id="element-124" data-mp="11zr37t0wofbv">$19.990</p>
                <p className="text-xs text-slate-400" data-id="element-125" data-mp="11xwf65uc873k">ARS</p>
              </div>
            </div>
          </motion.div>
          <ActionButton className="mt-7" showTrust data-id="element-126" data-mp="3f78uylca9riv">
            🌿 QUIERO MI PROTOCOLO AHORA
          </ActionButton>
        </div>
      </div>
    </section>;
}